export default {

  redirectToProfessionalCompanyAddresses () {
    return this.$router.push({name: 'professional.company.addresses.index'})
  },
  redirectToProfessionalcompanyPrices () {
    return this.$router.push({name: 'professional.company.prices.index'})
  },
  nextSetpProfessionalAgendaRules () {
    return this.$router.push({name: 'professional.agenda.rules.index'})
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/agendas/components/resources/methods.js